import getLocalString from "constants/Localization";
import { useAddJobPhaseFileMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useAddJobPhaseFile() {
  const [mutation, { loading, data, error }] = useAddJobPhaseFileMutation();
  const [addJobPhaseFile, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "addJobPhaseFile",
    },
    {
      successMessage: getLocalString("jobPhases.add-job-phase-file-success"),
      failureMessage: getLocalString("jobPhases.add-job-phase-file-failure"),
    }
  );

  return [addJobPhaseFile, context] as const;
}
